import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  doc,
  addDoc,
  getFirestore,
  getDocs,
  collection,
  query,
  where,
  setDoc,
} from "firebase/firestore";
import "../../styles/login.css";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import GoogleSignUp from "../../assets/icons/svg/google.svg";

// import "./styles.css"; // Import the CSS file
import Header from "../../Components/update/Header";
import { useAppContext } from "../../context/AppContext";
import {
  createUserWithEmailAndPassword,
  validatePassword,
} from "firebase/auth";
import { auth, firestore } from "../../utils/firebase";

export default function Register() {
  const { setUser } = useAppContext();
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(false);
  const [method, setMethod] = useState("email");

  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    error: "",
  });

  const setupRecaptcha = () => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      {
        size: "invisible",
      }
    );
  };
  const setupRecaptchax = () => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      {
        size: "normal",
        callback: (response) => {
          // reCAPTCHA solved , allow signInWith PhoneNumber
          console.log(response);
        },
        "expired-callback": () => {
          // Response expired. Ask user to solve reCAPTCHA
          // return user to previous state.
          console.log("captcha Expired ...");
        },
      }
    );
  };

  const signUp = async () => {
    try {
      const emailExists = await checkEmailExists();

      if (emailExists) {
        throw new Error("Email already registered!");
      }
      const res = await createUserWithEmailAndPassword(
        auth,
        data.email,
        data.password
      );
      saveUser();
      localStorage.setItem("user", JSON.stringify(res.user));
      setUser(res.user);
    } catch (error) {
      setData((prev) => ({ ...prev, error: error.message }));
      console.log(error);
    }
  };
  const checkEmailExists = async () => {
    try {
      const usersRef = collection(firestore, "users");
      const q = query(usersRef, where("email", "==", data.email));
      const querySnapShot = await getDocs(q);
      console.log(!querySnapShot.empty);
      //   return querySnapShot.empty; //true if email exists, false otherwise
      return !querySnapShot.empty; //true if email exists, false otherwise
    } catch (error) {
      setData((prev) => ({ ...prev, error: error.message }));
      console.log(error);
    }
  };

  const sendOtp = () => {
    setupRecaptcha();
    try {
      const confirmationResult = signInWithPhoneNumber(
        auth,
        data.phone,
        window.recaptchaVerifier
      );
      setConfirmationResult(confirmationResult);
    } catch (error) {
      console.log(error);
    }
  };
  const verifyOtp = () => {
    if (!confirmationResult) return;

    try {
      const userCredentials = confirmationResult.confirm(otp);
      console.log(userCredentials);
    } catch (error) {
      console.log(error);
    }
  };

  const saveUser = async () => {
    try {
      const collectionRef = collection(firestore, "users");
      // store additional user info in firestore
      await addDoc(collectionRef, {
        name: data.name,
        email: data.email,
        avatar: null,
        createdAt: new Date(),
      });
    } catch (error) {
      console.log(error);
    }
  };
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const updateSignMethod = () => {
    if (method == "email") {
      setMethod("phone");
      return;
    }
    setMethod("email");
  };

  const signUpGoogle = () => {
    try {
    } catch (error) {}
  };
  return (
    <div className="pt-5">
      <Header />
      <div className="container">
        <div className="form-box">
          <h2 onClick={setupRecaptcha}>Register</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              console.log("form submitted");
            }}
          >
            {method == "email" ? (
              <>
                <input
                  type="text"
                  value={data.name}
                  placeholder="Full Name"
                  className="input-box"
                  onChange={(e) =>
                    setData((prev) => ({ ...prev, name: e.target.value }))
                  }
                />
                <input
                  type="email"
                  value={data.email}
                  placeholder="Email"
                  autoComplete="off"
                  className="input-box"
                  onChange={(e) =>
                    setData((prev) => ({ ...prev, email: e.target.value }))
                  }
                />
                <input
                  type="password"
                  value={data.password}
                  placeholder="Password"
                  className="input-box"
                  onChange={(e) =>
                    setData((prev) => ({ ...prev, password: e.target.value }))
                  }
                />
              </>
            ) : (
              <input
                type="number"
                value={data.phone}
                placeholder="+12345678912"
                className="input-box"
                onChange={(e) =>
                  setData((prev) => ({ ...prev, phone: e.target.value }))
                }
              />
            )}

            <p className="error">{data.error}</p>
            <button type="button" className="btn" onClick={signUp}>
              {/* <button type="button" className="btn" onClick={signUp}> */}
              {/* <button className="btn" onClick={signUp}> */}
              Sign Up
            </button>
          </form>
          <div className="flex mt-4">
            <button
              onClick={() => setMethod("google")}
              style={{ width: "50%" }}
            >
              <img src={GoogleSignUp} style={{ height: "100%" }} />
            </button>
            <button
              onClick={updateSignMethod}
              className="flex items-center text-red-400"
            >
              {method === "email" ? (
                <>
                  <span style={{ fontSize: 40, marginRight: 8 }}>📱</span> Sign
                  Up
                </>
              ) : (
                <p className="ml-3">Sign Up Email</p>
              )}
            </button>
          </div>
          <p className="mt-4 text-rose-800">
            Already have an account?{" "}
            <Link to="/login" className="link">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
